// src/native/compliance/ProcessorTable.jsx
//
// WS-7 COMPLIANCE. The "who gets what, and why" list required by App Store
// Guideline 5.1.2(i). Shared by the first-run consent screen and by the Settings
// detail sheet so the two can never drift apart.
//
// Rendered as a list of cards rather than a real table on purpose: the primary
// viewport is a phone, and a three column table at 360px is unreadable for the
// parents this screen is written for.

import React from 'react';
import {
  ChatCircleText,
  Microphone,
  SpeakerHigh,
  Translate,
} from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import { AI_PROCESSORS } from './consentConfig';

const ICONS = {
  anthropic: ChatCircleText,
  google: ChatCircleText,
  openai: Translate,
  deepgram: Microphone,
  elevenlabs: SpeakerHigh,
};

export default function ProcessorTable({ t, lightMode }) {
  return (
    <ul className="flex flex-col gap-2.5" role="list">
      {AI_PROCESSORS.map((proc) => {
        const Icon = ICONS[proc.id] || ChatCircleText;
        return (
          <li
            key={proc.id}
            className={cn(
              'flex items-start gap-3 rounded-2xl border p-3.5',
              lightMode ? 'bg-white border-gray-200' : 'bg-white/[0.06] border-white/10'
            )}
          >
            <span
              className={cn(
                'mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl',
                lightMode ? 'bg-[#F6EDE8]' : 'bg-white/10'
              )}
              aria-hidden="true"
            >
              <Icon
                weight="regular"
                className={cn('h-5 w-5', lightMode ? 'text-[#C8572A]' : 'text-[#E7A183]')}
              />
            </span>

            <div className="min-w-0 flex-1">
              <p
                className={cn(
                  'text-[15px] font-bold leading-tight',
                  lightMode ? 'text-gray-900' : 'text-white'
                )}
              >
                {proc.name}
              </p>
              <p
                className={cn(
                  'mt-1 text-[13px] leading-snug',
                  lightMode ? 'text-gray-700' : 'text-white/80'
                )}
              >
                {t('native.consent.getsLabel')} {t(proc.receivesKey)}
              </p>
              <p
                className={cn(
                  'mt-0.5 text-[13px] leading-snug',
                  lightMode ? 'text-gray-500' : 'text-white/60'
                )}
              >
                {t('native.consent.forLabel')} {t(proc.purposeKey)}
              </p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
